// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"8243db05","133":"d7349e2d","182":"7a57783f"}[chunkId] + ".chunk.js";
};